var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 59,
    viewBox: "0 0 83 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 19.2L35 25.8L39.1 21.5L33 15.1C28.7 10.6 22.6 8 16.4 8H3.5C1.8 8 0.5 9.3 0.5 11C0.5 12.7 1.8 14 3.5 14H9.1H16.4C21 13.9 25.5 15.9 28.7 19.2Z",
    fill: "#0F67BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4 36.7L51.5 43.1C55.8 47.6 61.9 50.2 68.1 50.2H70V56.2C70 57 70.5 57.7 71.2 58C71.4 58.1 71.7 58.2 72 58.2C72.5 58.2 73 58 73.4 57.6L82.4 48.6C82.8 48.2 83 47.7 83 47.2C83 46.7 82.8 46.2 82.4 45.8L73.4 36.8C72.8 36.2 72 36.1 71.2 36.4C70.5 36.7 70 37.4 70 38.2V44.2H68.1C67 44.2 65.9 44.1 64.8 43.9C61.5 43.2 58.5 41.6 56.1 39.2C56 39.1 55.9 39 55.8 39L49.5 32.4L45.4 36.7Z",
    fill: "#0F67BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4 0.6C73 0.2 72.5 0 72 0C71.7 0 71.5 7.59959e-07 71.2 0.200001C70.5 0.500001 70 1.2 70 2V7.5H68.1C61.7 7.5 55.5 10.2 51.1 14.8L28.3 38.6C25.2 41.9 20.8 43.7 16.4 43.7H3.5C1.6 43.7 0 45.3 0 47.2C0 49.1 1.6 50.7 3.5 50.7H16.4C22.8 50.7 29 48 33.4 43.4L56.2 19.5C59.3 16.2 63.7 14.4 68.1 14.4H70V19.9C70 20.7 70.5 21.4 71.2 21.7C71.4 21.8 71.7 21.9 72 21.9C72.5 21.9 73 21.7 73.4 21.3L82.4 12.3C82.8 11.9 83 11.4 83 10.9C83 10.4 82.8 9.9 82.4 9.5L73.4 0.6Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.ea821ddd4ccfe64d2bf2cb533d25de9e.svg";
export { ForwardRef as ReactComponent };